import styled from 'styled-components';

export const Section = styled.section`
  background: #f4f3ef;
  border-bottom: 1px solid rgba(101, 116, 85, 0.12);
  padding: 2.25rem 1.5rem;
`;

export const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.75rem;
`;

export const Label = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #657455;
  white-space: nowrap;
`;

export const Logos = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 2.5rem 3.5rem;
  flex-wrap: wrap;
  width: 100%;
`;

export const Partner = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  text-decoration: none;
  width: 220px;
  max-width: 100%;

  @media (max-width: 600px) {
    width: 160px;
  }
`;

export const LogoBox = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background: transparent;
  transition: transform 0.2s ease;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
  }

  ${Partner}:hover & {
    transform: translateY(-3px);
  }

  @media (max-width: 600px) {
    height: 88px;
  }
`;

export const PartnerName = styled.span`
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: #3a3a35;
  text-align: center;
  line-height: 1.3;
`;
